(function () {
  'use strict';

  const PRODUCT_BUTTON_SELECTOR = '.product-customization-options shipping-calculator #shippingEstimates, .cimo-pdp-v1 shipping-calculator #shippingEstimates';
  const STOREFRONT_API_VERSION = '2026-07';

  const CART_CREATE_QUERY = `
    mutation CimoShippingCartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart { id }
        userErrors { field message }
        warnings { code message }
      }
    }
  `;

  const SHIPPING_RATES_QUERY = `
    query CimoShippingRates($cartId: ID!) {
      cart(id: $cartId) {
        ...DeliveryGroups @defer
      }
    }

    fragment DeliveryGroups on Cart {
      deliveryGroups(first: 10, withCarrierRates: true) {
        edges {
          node {
            deliveryOptions {
              title
              deliveryMethodType
              estimatedCost {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `;

  function initProductShipping(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(PRODUCT_BUTTON_SELECTOR).forEach(function (button) {
      if (button.dataset.cimoProductShippingBound === 'true') return;
      button.dataset.cimoProductShippingBound = 'true';
      button.addEventListener('click', handleProductShippingClick, true);
    });
  }

  function getMessageBox(calculator, type) {
    if (type === 'success') return calculator.querySelector('#shippingResponse');
    return calculator.querySelector('#shippingErrors');
  }

  function resetFeedback(calculator) {
    const errors = getMessageBox(calculator, 'error');
    const success = getMessageBox(calculator, 'success');
    if (errors) errors.classList.add('hidden');
    if (success) {
      success.classList.add('hidden');
      success.innerHTML = '';
    }
  }

  function showError(calculator, message) {
    const errors = getMessageBox(calculator, 'error');
    if (!errors) return;
    const target = errors.querySelector('.errors') || errors;
    target.textContent = message;
    errors.classList.remove('hidden');
  }

  function setButtonLoading(button, isLoading) {
    const span = button.querySelector('span');
    if (isLoading) {
      if (span && !button.dataset.cimoOriginalText) {
        button.dataset.cimoOriginalText = span.textContent || '';
      }
      if (span) span.textContent = 'Calculando...';
      button.classList.add('loading');
      button.setAttribute('disabled', 'disabled');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('disabled');
    if (span && button.dataset.cimoOriginalText) {
      span.textContent = button.dataset.cimoOriginalText;
    }
  }

  function getProductScope(calculator) {
    return calculator.closest('.section-main-product') || document;
  }

  function currentVariantId(calculator) {
    const productForm = calculator.closest('product-form');
    let variantInput = productForm && productForm.querySelector('input.product-variant-id[name="id"]');

    if (!variantInput) {
      const scope = getProductScope(calculator);
      variantInput = scope.querySelector('.cimo-pdp-v1__form input.product-variant-id[name="id"], .main-product-form input.product-variant-id[name="id"]');
    }

    let value = variantInput && variantInput.value ? String(variantInput.value).trim() : '';

    if (!value) {
      value = new URL(window.location.href).searchParams.get('variant') || '';
    }

    if (!value) return '';
    return value.indexOf('gid://shopify/ProductVariant/') === 0
      ? value
      : `gid://shopify/ProductVariant/${value}`;
  }

  function currentQuantity(calculator) {
    const productForm = calculator.closest('product-form');
    let quantityInput = productForm && productForm.querySelector('input[name="quantity"]');

    if (!quantityInput) {
      const scope = getProductScope(calculator);
      quantityInput = scope.querySelector('.cimo-pdp-v1 input[name="quantity"], .main-product-form input[name="quantity"]');
    }

    const quantity = parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function storefrontEndpoint() {
    const shop = window.cimoPermanentShopDomain || (window.Shopify && window.Shopify.shop);
    if (!shop) throw new Error('Store domain unavailable');
    return `https://${shop}/api/${STOREFRONT_API_VERSION}/graphql.json`;
  }

  async function storefrontRequest(query, variables, accept) {
    const response = await fetch(storefrontEndpoint(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': accept || 'application/graphql-response+json, application/json'
      },
      body: JSON.stringify({ query: query, variables: variables })
    });

    if (!response.ok) {
      throw new Error(`Storefront API HTTP ${response.status}`);
    }

    return response;
  }

  function parseJsonPart(part) {
    const start = part.indexOf('{');
    const end = part.lastIndexOf('}');
    if (start === -1 || end === -1 || end < start) return null;
    try {
      return JSON.parse(part.slice(start, end + 1));
    } catch (error) {
      return null;
    }
  }

  async function parseStorefrontPayloads(response) {
    const contentType = response.headers.get('content-type') || '';

    if (contentType.toLowerCase().indexOf('multipart/mixed') === -1) {
      return [await response.json()];
    }

    const text = await response.text();
    const boundaryMatch = contentType.match(/boundary="?([^";]+)"?/i);
    const payloads = [];

    if (boundaryMatch && boundaryMatch[1]) {
      text.split(`--${boundaryMatch[1]}`).forEach(function (part) {
        const payload = parseJsonPart(part);
        if (payload) payloads.push(payload);
      });
    }

    if (payloads.length === 0) {
      text.split(/\r?\n/).forEach(function (line) {
        const trimmed = line.trim();
        if (!trimmed || trimmed.charAt(0) !== '{') return;
        try {
          payloads.push(JSON.parse(trimmed));
        } catch (error) {
          // Ignore non-JSON transport lines.
        }
      });
    }

    return payloads;
  }

  function collectDeliveryOptions(value, output) {
    if (!value) return;

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        collectDeliveryOptions(item, output);
      });
      return;
    }

    if (typeof value !== 'object') return;

    if (Array.isArray(value.deliveryOptions)) {
      value.deliveryOptions.forEach(function (option) {
        if (option && option.title) output.push(option);
      });
    }

    Object.keys(value).forEach(function (key) {
      if (key !== 'deliveryOptions') collectDeliveryOptions(value[key], output);
    });
  }

  function uniqueDeliveryOptions(payloads) {
    const options = [];
    payloads.forEach(function (payload) {
      collectDeliveryOptions(payload, options);
    });

    const deduped = new Map();
    options.forEach(function (option) {
      const cost = option.estimatedCost || {};
      const key = [option.title, cost.amount, cost.currencyCode, option.deliveryMethodType].join('|');
      if (!deduped.has(key)) deduped.set(key, option);
    });
    return Array.from(deduped.values());
  }

  function formatMoney(amount, currencyCode) {
    const numeric = Number(amount);
    if (!Number.isFinite(numeric)) return '';
    if (numeric === 0) return 'Grátis';

    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: currencyCode || 'BRL'
      }).format(numeric);
    } catch (error) {
      return `R$ ${numeric.toFixed(2).replace('.', ',')}`;
    }
  }

  function renderRates(calculator, rates, cepData) {
    const success = getMessageBox(calculator, 'success');
    if (!success) return;

    success.innerHTML = '';

    const heading = document.createElement('p');
    const destination = [cepData.localidade, cepData.uf].filter(Boolean).join('/');
    heading.textContent = destination ? `Frete para ${destination}` : 'Opções de frete';
    heading.style.fontWeight = '600';
    success.appendChild(heading);

    rates.forEach(function (rate) {
      const child = document.createElement('p');
      const cost = rate.estimatedCost || {};
      const formatted = formatMoney(cost.amount, cost.currencyCode);
      child.textContent = formatted ? `${rate.title}: ${formatted}` : rate.title;
      success.appendChild(child);
    });

    success.classList.remove('hidden');
  }

  async function lookupCep(cleanedZip) {
    const response = await fetch(`https://viacep.com.br/ws/${cleanedZip}/json/`);
    if (!response.ok) throw new Error(`ViaCEP HTTP ${response.status}`);
    const data = await response.json();
    if (data.erro || !data.uf) throw new Error('Invalid ZIP');
    return data;
  }

  async function createTemporaryCart(variantId, quantity, cleanedZip, cepData) {
    const input = {
      lines: [{ quantity: quantity, merchandiseId: variantId }],
      buyerIdentity: { countryCode: 'BR' },
      delivery: {
        addresses: [{
          selected: true,
          oneTimeUse: true,
          validationStrategy: 'COUNTRY_CODE_ONLY',
          address: {
            deliveryAddress: {
              zip: cleanedZip,
              city: cepData.localidade || undefined,
              provinceCode: cepData.uf,
              countryCode: 'BR'
            }
          }
        }]
      }
    };

    const response = await storefrontRequest(CART_CREATE_QUERY, { input: input });
    const payload = await response.json();
    const result = payload && payload.data && payload.data.cartCreate;

    if (!result || !result.cart || !result.cart.id) {
      const userError = result && result.userErrors && result.userErrors[0];
      const graphError = payload && payload.errors && payload.errors[0];
      throw new Error((userError && userError.message) || (graphError && graphError.message) || 'Temporary cart creation failed');
    }

    return result.cart.id;
  }

  async function getShippingRates(cartId) {
    const response = await storefrontRequest(
      SHIPPING_RATES_QUERY,
      { cartId: cartId },
      'multipart/mixed; deferSpec=20220824, application/graphql-response+json, application/json'
    );
    const payloads = await parseStorefrontPayloads(response);

    const graphErrors = [];
    payloads.forEach(function (payload) {
      if (payload && Array.isArray(payload.errors)) {
        payload.errors.forEach(function (error) {
          if (error && error.message) graphErrors.push(error.message);
        });
      }
    });

    const rates = uniqueDeliveryOptions(payloads);
    if (rates.length === 0 && graphErrors.length > 0) {
      throw new Error(graphErrors[0]);
    }
    return rates;
  }

  async function handleProductShippingClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const button = event.currentTarget;
    const calculator = button.closest('shipping-calculator');
    if (!calculator) return;

    resetFeedback(calculator);
    const zipInput = calculator.querySelector('#shippingZip');
    const cleanedZip = (zipInput && zipInput.value ? zipInput.value : '').replace(/\D/g, '');

    if (cleanedZip.length !== 8) {
      if (zipInput) zipInput.classList.add('invalid');
      showError(calculator, 'Informe um CEP válido com 8 dígitos.');
      return;
    }

    if (zipInput) zipInput.classList.remove('invalid');

    const variantId = currentVariantId(calculator);
    if (!variantId) {
      showError(calculator, 'Selecione uma opção do produto antes de calcular o frete.');
      return;
    }

    setButtonLoading(button, true);

    try {
      const cepData = await lookupCep(cleanedZip);
      const cartId = await createTemporaryCart(
        variantId,
        currentQuantity(calculator),
        cleanedZip,
        cepData
      );
      const rates = await getShippingRates(cartId);

      if (rates.length === 0) {
        showError(calculator, 'Não encontramos opções de frete para este CEP e produto.');
        return;
      }

      renderRates(calculator, rates, cepData);
    } catch (error) {
      console.error('CIMO product shipping estimate failed:', error);
      showError(calculator, 'Não foi possível calcular o frete agora. Tente novamente.');
    } finally {
      setButtonLoading(button, false);
    }
  }

  initProductShipping(document);

  document.addEventListener('DOMContentLoaded', function () {
    initProductShipping(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductShipping(event.target);
  });
})();
